(function () {
  function setup(el) {
    if (el.dataset.autoplayFadeBound) return;
    el.dataset.autoplayFadeBound = 'true';

    var seconds = parseFloat(el.getAttribute('data-autoplay-seconds')) || 3;
    var timer = null;

    function tick() {
      if (document.hidden || el.matches(':hover') || el.hasAttribute('dragging')) return;
      if (typeof el.next === 'function') {
        el.next(undefined, { animate: false });
      }
    }

    function start() {
      if (timer) return;
      timer = setInterval(tick, seconds * 1000);
    }

    start();
  }

  function init() {
    document.querySelectorAll('media-gallery slideshow-component[autoplay-fade]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
